import React, { useEffect, useRef, useState } from 'react'
import { AiFillEye, AiFillGithub } from 'react-icons/ai'
import { motion } from 'framer-motion'
import AppWrap from '../../wrapper/AppWrap'
import { client, urlFor } from '../../client';
import './Work.scss'
import MotionWrap from '../../wrapper/MotionWrap';

import { RiArrowDropDownLine } from 'react-icons/ri'
import { RiArrowDropUpLine } from 'react-icons/ri'


const Work = () => {
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [num, setnum] = useState(8);
  const [activeFilter, setActiveFilter] = useState('All');
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const buttonRef = useRef(null);

  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      setWorks(data);
      setFilterWork(data);
    });
  }, [num]);

  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };

  const handleClick = () => {
    // set num and then scroll to buttonRef
    console.log(num);
    console.log(filterWork.length);
    setnum(num +1);
    window.scrollTo({
      top: buttonRef.current.offsetTop - 400,
      behavior: "smooth"
    });
  };

  return (
    <>
      <h2 className="head-text" style={{ marginTop: 50 }}>My Creative  <span>Portfolio</span> Section </h2>
      {/* <div className="app__Work-filter  d-flex justify-content-center align-items-center gap-2">
        {['Ui Developer', 'freelance work', 'Web App', 'React.Js', 'Angular', 'All'].map((item, index) => (
          <div key={index} onClick={() => handleWorkFilter(item)} className={`app__Work-filter-item app__flex  p-text ${activeFilter === item ? 'item-active' : ''}`} >
            {item}
          </div>
        ))
        }
      </div> */}

      <motion.div className="app__work-portfolio" animate={animateCard} transition={{ duration: 0.5, delayChildren: 0.5 }}>

        {filterWork.slice(0, num).map((work, index) => (
          <div className="app__work-item app__flex" key={index}>
            <div className="app__work-img app__flex"  >
              <img src={urlFor(work.imgUrl)} alt={work.name} />
              <motion.div className="app__work-hover app__flex" whileHover={{ opacity: [0, 1] }} transition={{ duration: 0.25, ease: 'easeInOut', staggerChildren: 0.5 }}>
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div className="app__flex" whileInView={{ scale: [0, 1] }} whileHover={{ scale: [1, 0.90] }} transition={{ duration: 0.25 }}  >
                    <AiFillEye />
                  </motion.div>
                </a>

                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div className="app__flex" whileInView={{ scale: [0, 1] }} whileHover={{ scale: [1, 0.90] }} transition={{ duration: 0.25 }}>
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>

            <div className="app__work-content app__flex">
              <h4 className="bold-text">{work.title}</h4>
              <p className="p-text text-center" style={{ marginTop: 10 }}>{work.description}</p>

              <div className="app__work-tag app__flex">
                <p className="p-text">{work.tags[0]}</p>
              </div>
            </div>
          </div>
        ))}

      </motion.div>

      {Number(filterWork.length) === Number(num) ?
        <button type="button" className="show_More p-text d-flex  justify-content-center align-items-center" onClick={() => {
          setnum(8);
          window.location.href = "#works";
        }}>
          <span>Show Less</span>
          <RiArrowDropUpLine size={20} />
        </button>
        :
        <button type="button" ref={buttonRef} className="show_More p-text d-flex  justify-content-center align-items-center" onClick={handleClick}>
          <span>Show More</span>
          <RiArrowDropDownLine size={20} />
        </button>
      }


    </>
  )
}


export default AppWrap(
  MotionWrap(Work, 'app__works'),
  'works',
  'app__primarybg',
);